import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
import HomeComponent from '@/components/home/home.vue';
import OfferComponent from '@/components/offer/offer.vue';
import OfferListComponent from '@/components/offer/list/offer-list.vue';
import ItemDetailsComponent from '@/components/items/details/item-details.vue';
import ArchiveComponent from '@/components/archive/archive.vue';
import ArchiveListComponent from '@/components/archive/list/archive-list.vue';
import NotFoundComponent from '@/components/not-found/not-found.vue';
import $ from 'jquery';
import i18n, {availableLocales, defaultLocale} from "@/i18n/i18n.config";

Vue.use(VueRouter);

export enum RouteName {
    home = 'home',
    contact = 'contact',
    offerList = 'offer:list',
    offerDetails = 'offer:details',
    offerDetailsOnlyId = 'offer:details:only-id',
    archiveList = 'archive:list',
    archiveDetails = 'archive:details',
    archiveDetailsOnlyId = 'archive:details:only-id',
    notFound = 'notFound',
}

const legacyRoutes: RouteConfig[] = [
    {
        path: '/Łodzie/:itemId',
        redirect: '/pl/oferta/:itemId'
    },
    {
        path: '/Łodzie/:itemId/:itemName',
        redirect: '/pl/oferta/:itemName/:itemId'
    },
    {
        path: '/Oferta',
        redirect: '/pl/oferta'
    },
    {
        path: '/Kontakt',
        redirect: {name: RouteName.home, params: {locale: defaultLocale}, hash: '#kontakt'}
    },
    {
        path: '/Index',
        redirect: '/pl'
    }
];

const routes: RouteConfig[] = [
    {
        path: '/',
        redirect: `/${defaultLocale}`
    },
    {
        path: `/:locale(${availableLocales.join('|')})`,
        component: {
            render: (c) => c('router-view')
        },
        children: [
            {
                path: '',
                name: RouteName.home,
                component: HomeComponent,
                props: {contact: false}
            },
            {
                path: 'kontakt',
                name: RouteName.contact,
                component: HomeComponent,
                props: {contact: true}
            },
            {
                path: 'oferta',
                component: OfferComponent,
                children: [
                    {
                        path: '',
                        name: RouteName.offerList,
                        component: OfferListComponent,
                        meta: {
                            currentOffer: true
                        },
                    },
                    {
                        path: ':itemName/:itemId(\\d+)',
                        name: RouteName.offerDetails,
                        component: ItemDetailsComponent,
                        props: true,
                        meta: {
                            archive: false,
                            currentOffer: true,
                        }
                    },
                    {
                        path: ':itemId(\\d+)',
                        name: RouteName.offerDetailsOnlyId,
                        component: ItemDetailsComponent,
                        props: true,
                        meta: {
                            archive: false,
                            currentOffer: true,
                        }
                    }
                ]
            },
            {
                path: 'archiwum',
                component: ArchiveComponent,
                children: [
                    {
                        path: '',
                        name: RouteName.archiveList,
                        component: ArchiveListComponent,
                        props: true,
                    },
                    {
                        path: ':itemName/:itemId(\\d+)',
                        name: RouteName.archiveDetails,
                        component: ItemDetailsComponent,
                        props: true,
                        meta: {
                            archive: true
                        }
                    },
                    {
                        path: ':itemId(\\d+)',
                        name: RouteName.archiveDetailsOnlyId,
                        component: ItemDetailsComponent,
                        props: true,
                        meta: {
                            archive: true
                        }
                    }
                ]
            }
        ]
    },
    {
        path: '*',
        name: RouteName.notFound,
        component: NotFoundComponent,
        meta: {
            notFound: true
        }
    },
    ...legacyRoutes
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.name === RouteName.archiveList && from.name === to.name) {
            return;
        }
        if (savedPosition) {
            return savedPosition
        } else {
            return {x: 0, y: 0}
        }
    }
});

router.beforeEach(async (to, from, next) => {
    const paramsLocale = to.params.locale;
    if (paramsLocale && !availableLocales.includes(paramsLocale)) {
        return next({name: RouteName.notFound});
    }
    i18n.locale = paramsLocale || defaultLocale;

    if (to.hash) {
        await next();
        scrollTo(($(to.hash) as any).offset().top - 75);
        return;
    } else if (from.name === to.name && !to.hash && to.name !== RouteName.archiveList) {
        scrollTo(0);
        next();
    } else if (from.name !== to.name) {
        await next();
    } else {
        next();
    }

    function scrollTo(position) {
        $('html, body').animate({
            scrollTop: position
        }, 700);
    }
});

export default router;
